import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="bg-ov-navy py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="relative overflow-hidden rounded-t-[120px] rounded-b-2xl border border-white/15 aspect-[4/5] max-w-md">
                <img src={IMAGES.founder} alt="Er. Dhamodhar Molugu" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-5 -right-3 bg-ov-greenBright text-ov-navy px-6 py-4 rounded-2xl">
                <div className="font-display text-lg leading-tight">B.Tech</div>
                <div className="font-body text-xs uppercase tracking-wider">Civil Engineering</div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <p className="font-body text-xs uppercase tracking-[0.2em] font-semibold text-ov-greenBright mb-8">
              From the Founder
            </p>
            <blockquote className="font-display text-3xl md:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
              <span className="text-ov-greenBright">“</span>Build properties that are
              protected by law — not lived in fear of it.<span className="text-ov-greenBright">”</span>
            </blockquote>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="mt-10 flex items-center gap-4"
            >
              <div className="w-12 h-px bg-ov-greenBright" />
              <div>
                <div className="font-display text-xl text-white">Er. Dhamodhar Molugu</div>
                <div className="font-body text-sm text-white/60">Founder — One Vision</div>
              </div>
            </motion.div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
